import * as React from "react";

const StatisticButton = ({ icon, count, label, filterType, isActive, setActiveFilter, onColor, description }) => {
    const baseClasses =
        "flex gap-[3px] items-center text-center w-[154px] min-h-[38px] rounded-3xl cursor-pointer transition-all duration-200  px-[12px] py-[8px] relative";
    const activeClasses = isActive
        ? `bg-white outline outline-2 outline-[${onColor}] px-[12px] py-[8px]`
        : "bg-neutral-100 outline hover:outline outline-1 outline-gray-300 px-[12px] py-[8px]";
    const countColor = isActive ? `text-[${onColor}]` : "text-zinc-600";

    const [showTooltip, setShowTooltip] = React.useState(false); // 툴팁 상태 관리


    return (
        <div
            className={` ${activeClasses} ${baseClasses}`}
            onClick={() => setActiveFilter(isActive ? null : filterType)} // 활성화/비활성화 처리
            onMouseEnter={() => description && setShowTooltip(true)} // 마우스를 올리면 툴팁 활성화
            onMouseLeave={() => setShowTooltip(false)} // 마우스를 떼면 툴팁 비활성화
        >
            <img
                loading="lazy"
                src={icon}
                alt=""
                className="object-contain shrink-0 self-stretch my-auto aspect-square w-[22px]"
            />
            <div className={`self-stretch my-auto w-[22px] text-base font-bold ${countColor}`}>
                {count}
            </div>
            <div className="self-stretch my-auto text-sm font-medium text-gray-400 w-[76px]">
                {label}
            </div>
            {/* 툴팁 표시 */}
            {showTooltip && (
                <div
                    className="absolute top-[-25px] left-[80%] transform -translate-x-1/2 bg-black text-white text-xs rounded-md p-[6px] shadow-lg z-10 whitespace-nowrap">
                    {description}
                </div>
            )}
        </div>
    );
};
export default StatisticButton;